import React from 'react';
import FamilyCard from './FamilyCard';

const body = [
  'The Rivera-Mwangi lineage culminates at the farthest edge of human civilization. <strong class="text-white">Eseosa Rivera-Mwangi</strong>, Director of Neptune\'s Heliopause Observatory, was the first scientist to detect the signal from deep interstellar space — eleven days after her daughter Imogen departed aboard the Odyssey as its third-shift navigator toward Alpha Centauri.',
  'This family stood, generation after generation, at the boundary between the known and the unknown. They were watchers, patient and deliberate, embodying Neptune\'s culture of <strong class="text-white">sustained attention</strong>.',
  'When the chronicle ends, it is through their eyes: a mother at her observatory, a daughter outbound to the stars, a signal in the dark.',
];

const FamilyRivera = () => (
  <FamilyCard
    id="family-3"
    accentColor="text-blue-400"
    dotColor="bg-blue-400"
    borderColor="border-blue-500/20"
    bgGlow="bg-[radial-gradient(ellipse_at_bottom_right,_var(--tw-gradient-stops))] from-blue-900/10 via-transparent to-transparent"
    tag="The Sentinels at the Edge · Neptune / Interstellar"
    name="The Rivera-Mwangis"
    origin="Neptune · Triton Station · Interstellar"
    role="The Sentinels"
    body={body}
    quote="Go well. We are here. We will be here when you return."
    quoteSource="Eseosa Rivera-Mwangi, to her daughter Imogen, March 14, 2514"
  />
);

export default FamilyRivera;